import { render, staticRenderFns } from "./SegmentalControls.vue?vue&type=template&id=31c0d06f&"
import script from "./SegmentalControls.vue?vue&type=script&lang=js&"
export * from "./SegmentalControls.vue?vue&type=script&lang=js&"
import style0 from "./SegmentalControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports